import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogConfig } from './interfaces/dialog-config.interface';
import { DialogTipo } from './utils/dialog-type.enum';
import { Color } from '../../utils/color.enum';
import { IBtn } from '../interfaces/btn.interface';
import { FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app--dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  // keys para tipo de dialog
  dialogType = DialogTipo;

  tipo: string;
  toolbarColor: string;
  toolbarIcono: string;
  toolbarTitulo: string;
  mensaje: string;
  aceptarBtn: IBtn;
  cancelarBtn: IBtn;

  // valor para el campo input
  inputPlaceholder: string;
  inputValue: string;

  // valor para la casilla de confirmacion
  checkLabel: string;
  checkValue = false;

  dForm: FormGroup = null;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfig,
    private fb: FormBuilder,
  ) {

    this.dForm = this.fb.group({
      msg: [''],
      check: [false]
    });
    this.tipo = data.tipo || DialogTipo.INFO;
    this.toolbarColor = data.toolbarColor || Color.PRIMARY;
    this.toolbarIcono = data.toolbarIcono || 'info';
    this.toolbarTitulo = data.toolbarTitulo || 'ASIGNAR TITULO';
    this.mensaje = data.mensaje || 'ASIGNAR CUERPO DE MENSAJE';
    this.aceptarBtn = data.aceptarBtn || { texto: 'Aceptar', tipo: 'raised', color: Color.PRIMARY };
    this.cancelarBtn = data.cancelarBtn || { texto: 'Cancelar', tipo: 'raised' };


    this.inputPlaceholder = data.inputPlaceholder || 'INGRESAR TEXTO';
    this.checkLabel = data.checkLabel || 'Estoy de acuerdo y deseo continuar';

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
